import React from 'react';
import { Button, DatePicker, Space, Select } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

interface TransactionHeaderProps {
  selectedDate: Dayjs;
  onDateChange: (date: Dayjs) => void;
  onRefresh: () => void;
  loading: boolean;
}

const TransactionHeader: React.FC<TransactionHeaderProps> = ({
  selectedDate,
  onDateChange,
  onRefresh,
  loading,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Giao dịch đáo hạn theo tháng
          </h1>
          <p className="text-gray-600">
            Xem tất cả giao dịch đáo hạn trong tháng được chọn
          </p>
        </div>

        <Space size="middle">
          <DatePicker
            value={selectedDate}
            onChange={onDateChange}
            format="DD/MM/YYYY"
            placeholder="Chọn ngày"
            allowClear={false}
            className="w-40"
            disabled={loading}
          />

          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={onRefresh}
            loading={loading}
          >
            Làm mới
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default TransactionHeader;
